import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
	  }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	/** This field accepts both ISODateString and ISODateTimeStringexample: 1992-08-14 or 1992-08-14T03:42:00.000Z */
	DateTime: { input: any; output: any }
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
	JSON: { input: any; output: any }
}

export type AllBanner = {
	__typename?: 'AllBanner'
	items?: Maybe<Array<Maybe<Banner>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllButton = {
	__typename?: 'AllButton'
	items?: Maybe<Array<Maybe<Button>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllCategoriesconfig = {
	__typename?: 'AllCategoriesconfig'
	items?: Maybe<Array<Maybe<Categoriesconfig>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllCategory = {
	__typename?: 'AllCategory'
	items?: Maybe<Array<Maybe<Category>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllContactFormCategory = {
	__typename?: 'AllContactFormCategory'
	items?: Maybe<Array<Maybe<ContactFormCategory>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllContactFormConfiguration = {
	__typename?: 'AllContactFormConfiguration'
	items?: Maybe<Array<Maybe<ContactFormConfiguration>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllContactlabel = {
	__typename?: 'AllContactlabel'
	items?: Maybe<Array<Maybe<Contactlabel>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllContactlabelsconfig = {
	__typename?: 'AllContactlabelsconfig'
	items?: Maybe<Array<Maybe<Contactlabelsconfig>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllExternalLinkButton = {
	__typename?: 'AllExternalLinkButton'
	items?: Maybe<Array<Maybe<ExternalLinkButton>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllFaq = {
	__typename?: 'AllFaq'
	items?: Maybe<Array<Maybe<Faq>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllHomeAdditionalInfo = {
	__typename?: 'AllHomeAdditionalInfo'
	items?: Maybe<Array<Maybe<HomeAdditionalInfo>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllHomepageAdditionalInfo = {
	__typename?: 'AllHomepageAdditionalInfo'
	items?: Maybe<Array<Maybe<HomepageAdditionalInfo>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllIcon = {
	__typename?: 'AllIcon'
	items?: Maybe<Array<Maybe<Icon>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllInternalLinkButton = {
	__typename?: 'AllInternalLinkButton'
	items?: Maybe<Array<Maybe<InternalLinkButton>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllQuestion = {
	__typename?: 'AllQuestion'
	items?: Maybe<Array<Maybe<Question>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type AllSysAsset = {
	__typename?: 'AllSysAsset'
	items?: Maybe<Array<Maybe<SysAsset>>>
	total?: Maybe<Scalars['Int']['output']>
}

export type Banner = {
	__typename?: 'Banner'
	content?: Maybe<BannerContent>
	is_outlet?: Maybe<Scalars['Boolean']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type BannerContent = {
	__typename?: 'BannerContent'
	subtitle?: Maybe<Scalars['String']['output']>
	title?: Maybe<Scalars['String']['output']>
}

export type BannerContentWhere = {
	subtitle?: InputMaybe<Scalars['String']['input']>
	subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>
	subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	subtitle_ne?: InputMaybe<Scalars['String']['input']>
	subtitle_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum BannerOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type BannerWhere = {
	AND?: InputMaybe<Array<InputMaybe<BannerWhere>>>
	OR?: InputMaybe<Array<InputMaybe<BannerWhere>>>
	content?: InputMaybe<BannerContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	is_outlet?: InputMaybe<Scalars['Boolean']['input']>
	is_outlet_exists?: InputMaybe<Scalars['Boolean']['input']>
	is_outlet_ne?: InputMaybe<Scalars['Boolean']['input']>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Button = {
	__typename?: 'Button'
	content?: Maybe<ButtonContent>
	description?: Maybe<Scalars['String']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type ButtonContent = {
	__typename?: 'ButtonContent'
	actions?: Maybe<Scalars['JSON']['output']>
	label?: Maybe<Scalars['String']['output']>
	link?: Maybe<Link>
	link_in_new_tab?: Maybe<Scalars['Boolean']['output']>
	logged_link?: Maybe<Link>
	outlet_link?: Maybe<Link>
	outlet_logged_link?: Maybe<Link>
	type?: Maybe<Scalars['String']['output']>
}

export type ButtonContentWhere = {
	actions?: InputMaybe<Scalars['JSON']['input']>
	actions_exists?: InputMaybe<Scalars['Boolean']['input']>
	label?: InputMaybe<Scalars['String']['input']>
	label_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	label_ne?: InputMaybe<Scalars['String']['input']>
	label_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	link?: InputMaybe<LinkWhere>
	link_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_ne?: InputMaybe<Scalars['Boolean']['input']>
	logged_link?: InputMaybe<LinkWhere>
	logged_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	outlet_link?: InputMaybe<LinkWhere>
	outlet_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	outlet_logged_link?: InputMaybe<LinkWhere>
	outlet_logged_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	type_exists?: InputMaybe<Scalars['Boolean']['input']>
	type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	type_ne?: InputMaybe<Scalars['String']['input']>
	type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum ButtonOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type ButtonWhere = {
	AND?: InputMaybe<Array<InputMaybe<ButtonWhere>>>
	OR?: InputMaybe<Array<InputMaybe<ButtonWhere>>>
	content?: InputMaybe<ButtonContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description?: InputMaybe<Scalars['String']['input']>
	description_exists?: InputMaybe<Scalars['Boolean']['input']>
	description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description_ne?: InputMaybe<Scalars['String']['input']>
	description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Categoriesconfig = {
	__typename?: 'Categoriesconfig'
	content?: Maybe<CategoriesconfigContent>
	outlet_content?: Maybe<CategoriesconfigOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type CategoriesconfigContent = {
	__typename?: 'CategoriesconfigContent'
	related_categoriesConnection?: Maybe<CategoriesconfigContentRelatedCategoriesConnection>
}

export type CategoriesconfigContentRelated_CategoriesConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type CategoriesconfigContentRelatedCategoriesConnection = {
	__typename?: 'CategoriesconfigContentRelatedCategoriesConnection'
	edges?: Maybe<Array<Maybe<CategoriesconfigContentRelatedCategoriesEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoriesconfigContentRelatedCategoriesEdge = {
	__typename?: 'CategoriesconfigContentRelatedCategoriesEdge'
	node?: Maybe<CategoriesconfigContentRelatedCategoriesNode>
}

export type CategoriesconfigContentRelatedCategoriesNode = Category

export type CategoriesconfigContentRelatedCategoriesWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	category?: InputMaybe<CategoryWhere>
}

export type CategoriesconfigContentWhere = {
	related_categories?: InputMaybe<CategoriesconfigContentRelatedCategoriesWhere>
	related_categories_count?: InputMaybe<Scalars['Int']['input']>
	related_categories_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export enum CategoriesconfigOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type CategoriesconfigOutletContent = {
	__typename?: 'CategoriesconfigOutletContent'
	related_categoriesConnection?: Maybe<CategoriesconfigOutletContentRelatedCategoriesConnection>
}

export type CategoriesconfigOutletContentRelated_CategoriesConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type CategoriesconfigOutletContentRelatedCategoriesConnection = {
	__typename?: 'CategoriesconfigOutletContentRelatedCategoriesConnection'
	edges?: Maybe<
		Array<Maybe<CategoriesconfigOutletContentRelatedCategoriesEdge>>
	>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoriesconfigOutletContentRelatedCategoriesEdge = {
	__typename?: 'CategoriesconfigOutletContentRelatedCategoriesEdge'
	node?: Maybe<CategoriesconfigOutletContentRelatedCategoriesNode>
}

export type CategoriesconfigOutletContentRelatedCategoriesNode = Category

export type CategoriesconfigOutletContentRelatedCategoriesWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	category?: InputMaybe<CategoryWhere>
}

export type CategoriesconfigOutletContentWhere = {
	related_categories?: InputMaybe<CategoriesconfigOutletContentRelatedCategoriesWhere>
	related_categories_count?: InputMaybe<Scalars['Int']['input']>
	related_categories_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export type CategoriesconfigWhere = {
	AND?: InputMaybe<Array<InputMaybe<CategoriesconfigWhere>>>
	OR?: InputMaybe<Array<InputMaybe<CategoriesconfigWhere>>>
	content?: InputMaybe<CategoriesconfigContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<CategoriesconfigOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Category = {
	__typename?: 'Category'
	content?: Maybe<CategoryContent>
	outlet_content?: Maybe<CategoryOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type CategoryContent = {
	__typename?: 'CategoryContent'
	common_related_questionsConnection?: Maybe<CategoryContentCommonRelatedQuestionsConnection>
	iconConnection?: Maybe<CategoryContentIconConnection>
	related_questionsConnection?: Maybe<CategoryContentRelatedQuestionsConnection>
	title?: Maybe<Scalars['String']['output']>
}

export type CategoryContentCommon_Related_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryContentRelated_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryContentCommonRelatedQuestionsConnection = {
	__typename?: 'CategoryContentCommonRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<CategoryContentCommonRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoryContentCommonRelatedQuestionsEdge = {
	__typename?: 'CategoryContentCommonRelatedQuestionsEdge'
	node?: Maybe<CategoryContentCommonRelatedQuestionsNode>
}

export type CategoryContentCommonRelatedQuestionsNode = Question

export type CategoryContentCommonRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type CategoryContentIconConnection = {
	__typename?: 'CategoryContentIconConnection'
	edges?: Maybe<Array<Maybe<CategoryContentIconEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoryContentIconEdge = {
	__typename?: 'CategoryContentIconEdge'
	node?: Maybe<CategoryContentIconNode>
}

export type CategoryContentIconNode = Icon

export type CategoryContentIconWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	icon?: InputMaybe<IconWhere>
}

export type CategoryContentRelatedQuestionsConnection = {
	__typename?: 'CategoryContentRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<CategoryContentRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoryContentRelatedQuestionsEdge = {
	__typename?: 'CategoryContentRelatedQuestionsEdge'
	node?: Maybe<CategoryContentRelatedQuestionsNode>
}

export type CategoryContentRelatedQuestionsNode = Question

export type CategoryContentRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type CategoryContentWhere = {
	common_related_questions?: InputMaybe<CategoryContentCommonRelatedQuestionsWhere>
	common_related_questions_count?: InputMaybe<Scalars['Int']['input']>
	common_related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	icon?: InputMaybe<CategoryContentIconWhere>
	icon_exists?: InputMaybe<Scalars['Boolean']['input']>
	related_questions?: InputMaybe<CategoryContentRelatedQuestionsWhere>
	related_questions_count?: InputMaybe<Scalars['Int']['input']>
	related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum CategoryOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type CategoryOutletContent = {
	__typename?: 'CategoryOutletContent'
	common_related_questionsConnection?: Maybe<CategoryOutletContentCommonRelatedQuestionsConnection>
	content_overwrite_selector?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	iconConnection?: Maybe<CategoryOutletContentIconConnection>
	related_questionsConnection?: Maybe<CategoryOutletContentRelatedQuestionsConnection>
	title?: Maybe<Scalars['String']['output']>
}

export type CategoryOutletContentCommon_Related_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryOutletContentRelated_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryOutletContentCommonRelatedQuestionsConnection = {
	__typename?: 'CategoryOutletContentCommonRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<CategoryOutletContentCommonRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoryOutletContentCommonRelatedQuestionsEdge = {
	__typename?: 'CategoryOutletContentCommonRelatedQuestionsEdge'
	node?: Maybe<CategoryOutletContentCommonRelatedQuestionsNode>
}

export type CategoryOutletContentCommonRelatedQuestionsNode = Question

export type CategoryOutletContentCommonRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type CategoryOutletContentIconConnection = {
	__typename?: 'CategoryOutletContentIconConnection'
	edges?: Maybe<Array<Maybe<CategoryOutletContentIconEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoryOutletContentIconEdge = {
	__typename?: 'CategoryOutletContentIconEdge'
	node?: Maybe<CategoryOutletContentIconNode>
}

export type CategoryOutletContentIconNode = Icon

export type CategoryOutletContentIconWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	icon?: InputMaybe<IconWhere>
}

export type CategoryOutletContentRelatedQuestionsConnection = {
	__typename?: 'CategoryOutletContentRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<CategoryOutletContentRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type CategoryOutletContentRelatedQuestionsEdge = {
	__typename?: 'CategoryOutletContentRelatedQuestionsEdge'
	node?: Maybe<CategoryOutletContentRelatedQuestionsNode>
}

export type CategoryOutletContentRelatedQuestionsNode = Question

export type CategoryOutletContentRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type CategoryOutletContentWhere = {
	common_related_questions?: InputMaybe<CategoryOutletContentCommonRelatedQuestionsWhere>
	common_related_questions_count?: InputMaybe<Scalars['Int']['input']>
	common_related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	content_overwrite_selector?: InputMaybe<Scalars['String']['input']>
	content_overwrite_selector_exists?: InputMaybe<Scalars['Boolean']['input']>
	content_overwrite_selector_in?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	content_overwrite_selector_ne?: InputMaybe<Scalars['String']['input']>
	content_overwrite_selector_nin?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	icon?: InputMaybe<CategoryOutletContentIconWhere>
	icon_exists?: InputMaybe<Scalars['Boolean']['input']>
	related_questions?: InputMaybe<CategoryOutletContentRelatedQuestionsWhere>
	related_questions_count?: InputMaybe<Scalars['Int']['input']>
	related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CategoryWhere = {
	AND?: InputMaybe<Array<InputMaybe<CategoryWhere>>>
	OR?: InputMaybe<Array<InputMaybe<CategoryWhere>>>
	content?: InputMaybe<CategoryContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<CategoryOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type ContactFormCategory = {
	__typename?: 'ContactFormCategory'
	category_id?: Maybe<Scalars['String']['output']>
	extra_inputs?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	final_date?: Maybe<Scalars['DateTime']['output']>
	initial_date?: Maybe<Scalars['DateTime']['output']>
	is_message_required?: Maybe<Scalars['Boolean']['output']>
	is_visible?: Maybe<Scalars['Boolean']['output']>
	label_key?: Maybe<Scalars['String']['output']>
	redirects_to_chatbot?: Maybe<Scalars['Boolean']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export enum ContactFormCategoryOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type ContactFormCategoryWhere = {
	AND?: InputMaybe<Array<InputMaybe<ContactFormCategoryWhere>>>
	OR?: InputMaybe<Array<InputMaybe<ContactFormCategoryWhere>>>
	category_id?: InputMaybe<Scalars['String']['input']>
	category_id_exists?: InputMaybe<Scalars['Boolean']['input']>
	category_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	category_id_ne?: InputMaybe<Scalars['String']['input']>
	category_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	extra_inputs?: InputMaybe<Scalars['String']['input']>
	extra_inputs_exists?: InputMaybe<Scalars['Boolean']['input']>
	extra_inputs_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	extra_inputs_ne?: InputMaybe<Scalars['String']['input']>
	extra_inputs_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	final_date?: InputMaybe<Scalars['DateTime']['input']>
	final_date_exists?: InputMaybe<Scalars['Boolean']['input']>
	final_date_gt?: InputMaybe<Scalars['DateTime']['input']>
	final_date_gte?: InputMaybe<Scalars['DateTime']['input']>
	final_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	final_date_lt?: InputMaybe<Scalars['DateTime']['input']>
	final_date_lte?: InputMaybe<Scalars['DateTime']['input']>
	final_date_ne?: InputMaybe<Scalars['DateTime']['input']>
	final_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	initial_date?: InputMaybe<Scalars['DateTime']['input']>
	initial_date_exists?: InputMaybe<Scalars['Boolean']['input']>
	initial_date_gt?: InputMaybe<Scalars['DateTime']['input']>
	initial_date_gte?: InputMaybe<Scalars['DateTime']['input']>
	initial_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	initial_date_lt?: InputMaybe<Scalars['DateTime']['input']>
	initial_date_lte?: InputMaybe<Scalars['DateTime']['input']>
	initial_date_ne?: InputMaybe<Scalars['DateTime']['input']>
	initial_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	is_message_required?: InputMaybe<Scalars['Boolean']['input']>
	is_message_required_exists?: InputMaybe<Scalars['Boolean']['input']>
	is_message_required_ne?: InputMaybe<Scalars['Boolean']['input']>
	is_visible?: InputMaybe<Scalars['Boolean']['input']>
	is_visible_exists?: InputMaybe<Scalars['Boolean']['input']>
	is_visible_ne?: InputMaybe<Scalars['Boolean']['input']>
	label_key?: InputMaybe<Scalars['String']['input']>
	label_key_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	label_key_ne?: InputMaybe<Scalars['String']['input']>
	label_key_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	redirects_to_chatbot?: InputMaybe<Scalars['Boolean']['input']>
	redirects_to_chatbot_exists?: InputMaybe<Scalars['Boolean']['input']>
	redirects_to_chatbot_ne?: InputMaybe<Scalars['Boolean']['input']>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type ContactFormConfiguration = {
	__typename?: 'ContactFormConfiguration'
	categories?: Maybe<ContactFormConfigurationCategories>
	chatbot_languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	show_gdpr_notice?: Maybe<Scalars['Boolean']['output']>
	show_privacy_notice?: Maybe<Scalars['Boolean']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type ContactFormConfigurationCategories = {
	__typename?: 'ContactFormConfigurationCategories'
	category_first_level?: Maybe<
		Array<Maybe<ContactFormConfigurationCategoriesCategoryFirstLevel>>
	>
}

export type ContactFormConfigurationCategoriesCategoryFirstLevel = {
	__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevel'
	category_first_level_referenceConnection?: Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceConnection>
	category_second_level?: Maybe<
		Array<
			Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevel>
		>
	>
}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceConnection =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceConnection'
		edges?: Maybe<
			Array<
				Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceEdge>
			>
		>
		totalCount?: Maybe<Scalars['Int']['output']>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceEdge =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceEdge'
		node?: Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceNode>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceNode =
	ContactFormCategory

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceWhere =
	{
		MATCH?: InputMaybe<EvalReferenceEnum>
		contact_form_category?: InputMaybe<ContactFormCategoryWhere>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevel =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevel'
		category_second_level_referenceConnection?: Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceConnection>
		category_third_level?: Maybe<
			Array<
				Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevel>
			>
		>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceConnection =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceConnection'
		edges?: Maybe<
			Array<
				Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceEdge>
			>
		>
		totalCount?: Maybe<Scalars['Int']['output']>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceEdge =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceEdge'
		node?: Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceNode>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceNode =
	ContactFormCategory

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceWhere =
	{
		MATCH?: InputMaybe<EvalReferenceEnum>
		contact_form_category?: InputMaybe<ContactFormCategoryWhere>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevel =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevel'
		category_third_level_referenceConnection?: Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceConnection>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceConnection =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceConnection'
		edges?: Maybe<
			Array<
				Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceEdge>
			>
		>
		totalCount?: Maybe<Scalars['Int']['output']>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceEdge =
	{
		__typename?: 'ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceEdge'
		node?: Maybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceNode>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceNode =
	ContactFormCategory

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceWhere =
	{
		MATCH?: InputMaybe<EvalReferenceEnum>
		contact_form_category?: InputMaybe<ContactFormCategoryWhere>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelWhere =
	{
		category_third_level_reference?: InputMaybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelCategoryThirdLevelReferenceWhere>
		category_third_level_reference_exists?: InputMaybe<
			Scalars['Boolean']['input']
		>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelWhere =
	{
		category_second_level_reference?: InputMaybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategorySecondLevelReferenceWhere>
		category_second_level_reference_exists?: InputMaybe<
			Scalars['Boolean']['input']
		>
		category_third_level?: InputMaybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelCategoryThirdLevelWhere>
		category_third_level_exists?: InputMaybe<Scalars['Boolean']['input']>
	}

export type ContactFormConfigurationCategoriesCategoryFirstLevelWhere = {
	category_first_level_reference?: InputMaybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategoryFirstLevelReferenceWhere>
	category_first_level_reference_exists?: InputMaybe<
		Scalars['Boolean']['input']
	>
	category_second_level?: InputMaybe<ContactFormConfigurationCategoriesCategoryFirstLevelCategorySecondLevelWhere>
	category_second_level_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export type ContactFormConfigurationCategoriesWhere = {
	category_first_level?: InputMaybe<ContactFormConfigurationCategoriesCategoryFirstLevelWhere>
	category_first_level_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export enum ContactFormConfigurationOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type ContactFormConfigurationWhere = {
	AND?: InputMaybe<Array<InputMaybe<ContactFormConfigurationWhere>>>
	OR?: InputMaybe<Array<InputMaybe<ContactFormConfigurationWhere>>>
	categories?: InputMaybe<ContactFormConfigurationCategoriesWhere>
	categories_exists?: InputMaybe<Scalars['Boolean']['input']>
	chatbot_languages?: InputMaybe<Scalars['String']['input']>
	chatbot_languages_exists?: InputMaybe<Scalars['Boolean']['input']>
	chatbot_languages_in?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	chatbot_languages_ne?: InputMaybe<Scalars['String']['input']>
	chatbot_languages_nin?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	show_gdpr_notice?: InputMaybe<Scalars['Boolean']['input']>
	show_gdpr_notice_exists?: InputMaybe<Scalars['Boolean']['input']>
	show_gdpr_notice_ne?: InputMaybe<Scalars['Boolean']['input']>
	show_privacy_notice?: InputMaybe<Scalars['Boolean']['input']>
	show_privacy_notice_exists?: InputMaybe<Scalars['Boolean']['input']>
	show_privacy_notice_ne?: InputMaybe<Scalars['Boolean']['input']>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Contactlabel = {
	__typename?: 'Contactlabel'
	content?: Maybe<ContactlabelContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type ContactlabelContent = {
	__typename?: 'ContactlabelContent'
	analytic_label?: Maybe<Scalars['String']['output']>
	description?: Maybe<Scalars['String']['output']>
	iconConnection?: Maybe<ContactlabelContentIconConnection>
	link?: Maybe<Link>
	link_in_new_tab?: Maybe<Scalars['Boolean']['output']>
	text?: Maybe<Scalars['String']['output']>
	title?: Maybe<Scalars['String']['output']>
	type?: Maybe<Scalars['String']['output']>
}

export type ContactlabelContentIconConnection = {
	__typename?: 'ContactlabelContentIconConnection'
	edges?: Maybe<Array<Maybe<ContactlabelContentIconEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type ContactlabelContentIconEdge = {
	__typename?: 'ContactlabelContentIconEdge'
	node?: Maybe<ContactlabelContentIconNode>
}

export type ContactlabelContentIconNode = Icon

export type ContactlabelContentIconWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	icon?: InputMaybe<IconWhere>
}

export type ContactlabelContentWhere = {
	analytic_label?: InputMaybe<Scalars['String']['input']>
	analytic_label_exists?: InputMaybe<Scalars['Boolean']['input']>
	analytic_label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	analytic_label_ne?: InputMaybe<Scalars['String']['input']>
	analytic_label_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description?: InputMaybe<Scalars['String']['input']>
	description_exists?: InputMaybe<Scalars['Boolean']['input']>
	description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description_ne?: InputMaybe<Scalars['String']['input']>
	description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	icon?: InputMaybe<ContactlabelContentIconWhere>
	icon_exists?: InputMaybe<Scalars['Boolean']['input']>
	link?: InputMaybe<LinkWhere>
	link_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_ne?: InputMaybe<Scalars['Boolean']['input']>
	text?: InputMaybe<Scalars['String']['input']>
	text_exists?: InputMaybe<Scalars['Boolean']['input']>
	text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	text_ne?: InputMaybe<Scalars['String']['input']>
	text_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	type?: InputMaybe<Scalars['String']['input']>
	type_exists?: InputMaybe<Scalars['Boolean']['input']>
	type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	type_ne?: InputMaybe<Scalars['String']['input']>
	type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum ContactlabelOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type ContactlabelWhere = {
	AND?: InputMaybe<Array<InputMaybe<ContactlabelWhere>>>
	OR?: InputMaybe<Array<InputMaybe<ContactlabelWhere>>>
	content?: InputMaybe<ContactlabelContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Contactlabelsconfig = {
	__typename?: 'Contactlabelsconfig'
	content?: Maybe<ContactlabelsconfigContent>
	outlet_content?: Maybe<ContactlabelsconfigOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type ContactlabelsconfigContent = {
	__typename?: 'ContactlabelsconfigContent'
	additional_info?: Maybe<Scalars['String']['output']>
	related_contact_labelsConnection?: Maybe<ContactlabelsconfigContentRelatedContactLabelsConnection>
}

export type ContactlabelsconfigContentRelated_Contact_LabelsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type ContactlabelsconfigContentRelatedContactLabelsConnection = {
	__typename?: 'ContactlabelsconfigContentRelatedContactLabelsConnection'
	edges?: Maybe<
		Array<Maybe<ContactlabelsconfigContentRelatedContactLabelsEdge>>
	>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type ContactlabelsconfigContentRelatedContactLabelsEdge = {
	__typename?: 'ContactlabelsconfigContentRelatedContactLabelsEdge'
	node?: Maybe<ContactlabelsconfigContentRelatedContactLabelsNode>
}

export type ContactlabelsconfigContentRelatedContactLabelsNode = Contactlabel

export type ContactlabelsconfigContentRelatedContactLabelsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	contactlabel?: InputMaybe<ContactlabelWhere>
}

export type ContactlabelsconfigContentWhere = {
	additional_info?: InputMaybe<Scalars['String']['input']>
	additional_info_exists?: InputMaybe<Scalars['Boolean']['input']>
	additional_info_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	additional_info_ne?: InputMaybe<Scalars['String']['input']>
	additional_info_nin?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	related_contact_labels?: InputMaybe<ContactlabelsconfigContentRelatedContactLabelsWhere>
	related_contact_labels_count?: InputMaybe<Scalars['Int']['input']>
	related_contact_labels_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export enum ContactlabelsconfigOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type ContactlabelsconfigOutletContent = {
	__typename?: 'ContactlabelsconfigOutletContent'
	additional_info?: Maybe<Scalars['String']['output']>
	related_contact_labelsConnection?: Maybe<ContactlabelsconfigOutletContentRelatedContactLabelsConnection>
}

export type ContactlabelsconfigOutletContentRelated_Contact_LabelsConnectionArgs =
	{
		limit?: InputMaybe<Scalars['Int']['input']>
		skip?: InputMaybe<Scalars['Int']['input']>
	}

export type ContactlabelsconfigOutletContentRelatedContactLabelsConnection = {
	__typename?: 'ContactlabelsconfigOutletContentRelatedContactLabelsConnection'
	edges?: Maybe<
		Array<Maybe<ContactlabelsconfigOutletContentRelatedContactLabelsEdge>>
	>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type ContactlabelsconfigOutletContentRelatedContactLabelsEdge = {
	__typename?: 'ContactlabelsconfigOutletContentRelatedContactLabelsEdge'
	node?: Maybe<ContactlabelsconfigOutletContentRelatedContactLabelsNode>
}

export type ContactlabelsconfigOutletContentRelatedContactLabelsNode =
	Contactlabel

export type ContactlabelsconfigOutletContentRelatedContactLabelsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	contactlabel?: InputMaybe<ContactlabelWhere>
}

export type ContactlabelsconfigOutletContentWhere = {
	additional_info?: InputMaybe<Scalars['String']['input']>
	additional_info_exists?: InputMaybe<Scalars['Boolean']['input']>
	additional_info_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	additional_info_ne?: InputMaybe<Scalars['String']['input']>
	additional_info_nin?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	related_contact_labels?: InputMaybe<ContactlabelsconfigOutletContentRelatedContactLabelsWhere>
	related_contact_labels_count?: InputMaybe<Scalars['Int']['input']>
	related_contact_labels_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export type ContactlabelsconfigWhere = {
	AND?: InputMaybe<Array<InputMaybe<ContactlabelsconfigWhere>>>
	OR?: InputMaybe<Array<InputMaybe<ContactlabelsconfigWhere>>>
	content?: InputMaybe<ContactlabelsconfigContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<ContactlabelsconfigOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type EntrySystemField = {
	__typename?: 'EntrySystemField'
	branch?: Maybe<Scalars['String']['output']>
	content_type_uid?: Maybe<Scalars['String']['output']>
	created_at?: Maybe<Scalars['DateTime']['output']>
	created_by?: Maybe<Scalars['String']['output']>
	extensionConnection?: Maybe<SysExtensionConnection>
	locale?: Maybe<Scalars['String']['output']>
	publish_details?: Maybe<SystemPublishDetails>
	tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	uid?: Maybe<Scalars['String']['output']>
	updated_at?: Maybe<Scalars['DateTime']['output']>
	updated_by?: Maybe<Scalars['String']['output']>
	version?: Maybe<Scalars['Int']['output']>
}

export type EntrySystemFieldExtensionConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export enum EvalReferenceEnum {
	All = 'ALL',
	Any = 'ANY',
}

export type ExternalLinkButton = {
	__typename?: 'ExternalLinkButton'
	content?: Maybe<ExternalLinkButtonContent>
	description?: Maybe<Scalars['String']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type ExternalLinkButtonContent = {
	__typename?: 'ExternalLinkButtonContent'
	actions?: Maybe<Scalars['JSON']['output']>
	label_key?: Maybe<Scalars['String']['output']>
	link?: Maybe<Link>
	link_in_new_tab?: Maybe<Scalars['Boolean']['output']>
	logged_link?: Maybe<Link>
	outlet_link?: Maybe<Link>
	outlet_logged_link?: Maybe<Link>
	type?: Maybe<Scalars['String']['output']>
}

export type ExternalLinkButtonContentWhere = {
	actions?: InputMaybe<Scalars['JSON']['input']>
	actions_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_key?: InputMaybe<Scalars['String']['input']>
	label_key_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	label_key_ne?: InputMaybe<Scalars['String']['input']>
	label_key_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	link?: InputMaybe<LinkWhere>
	link_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_ne?: InputMaybe<Scalars['Boolean']['input']>
	logged_link?: InputMaybe<LinkWhere>
	logged_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	outlet_link?: InputMaybe<LinkWhere>
	outlet_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	outlet_logged_link?: InputMaybe<LinkWhere>
	outlet_logged_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	type_exists?: InputMaybe<Scalars['Boolean']['input']>
	type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	type_ne?: InputMaybe<Scalars['String']['input']>
	type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum ExternalLinkButtonOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type ExternalLinkButtonWhere = {
	AND?: InputMaybe<Array<InputMaybe<ExternalLinkButtonWhere>>>
	OR?: InputMaybe<Array<InputMaybe<ExternalLinkButtonWhere>>>
	content?: InputMaybe<ExternalLinkButtonContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description?: InputMaybe<Scalars['String']['input']>
	description_exists?: InputMaybe<Scalars['Boolean']['input']>
	description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description_ne?: InputMaybe<Scalars['String']['input']>
	description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Faq = {
	__typename?: 'Faq'
	content?: Maybe<FaqContent>
	outlet_content?: Maybe<FaqOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type FaqContent = {
	__typename?: 'FaqContent'
	related_questions?: Maybe<Array<Maybe<FaqContentRelatedQuestions>>>
	title?: Maybe<Scalars['String']['output']>
}

export type FaqContentRelatedQuestions = {
	__typename?: 'FaqContentRelatedQuestions'
	related_categoryConnection?: Maybe<FaqContentRelatedQuestionsRelatedCategoryConnection>
	related_questionConnection?: Maybe<FaqContentRelatedQuestionsRelatedQuestionConnection>
}

export type FaqContentRelatedQuestionsRelatedCategoryConnection = {
	__typename?: 'FaqContentRelatedQuestionsRelatedCategoryConnection'
	edges?: Maybe<Array<Maybe<FaqContentRelatedQuestionsRelatedCategoryEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type FaqContentRelatedQuestionsRelatedCategoryEdge = {
	__typename?: 'FaqContentRelatedQuestionsRelatedCategoryEdge'
	node?: Maybe<FaqContentRelatedQuestionsRelatedCategoryNode>
}

export type FaqContentRelatedQuestionsRelatedCategoryNode = Category

export type FaqContentRelatedQuestionsRelatedCategoryWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	category?: InputMaybe<CategoryWhere>
}

export type FaqContentRelatedQuestionsRelatedQuestionConnection = {
	__typename?: 'FaqContentRelatedQuestionsRelatedQuestionConnection'
	edges?: Maybe<Array<Maybe<FaqContentRelatedQuestionsRelatedQuestionEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type FaqContentRelatedQuestionsRelatedQuestionEdge = {
	__typename?: 'FaqContentRelatedQuestionsRelatedQuestionEdge'
	node?: Maybe<FaqContentRelatedQuestionsRelatedQuestionNode>
}

export type FaqContentRelatedQuestionsRelatedQuestionNode = Question

export type FaqContentRelatedQuestionsRelatedQuestionWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type FaqContentRelatedQuestionsWhere = {
	related_category?: InputMaybe<FaqContentRelatedQuestionsRelatedCategoryWhere>
	related_category_exists?: InputMaybe<Scalars['Boolean']['input']>
	related_question?: InputMaybe<FaqContentRelatedQuestionsRelatedQuestionWhere>
	related_question_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export type FaqContentWhere = {
	related_questions?: InputMaybe<FaqContentRelatedQuestionsWhere>
	related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum FaqOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type FaqOutletContent = {
	__typename?: 'FaqOutletContent'
	related_questions?: Maybe<Array<Maybe<FaqOutletContentRelatedQuestions>>>
	title?: Maybe<Scalars['String']['output']>
}

export type FaqOutletContentRelatedQuestions = {
	__typename?: 'FaqOutletContentRelatedQuestions'
	related_categoryConnection?: Maybe<FaqOutletContentRelatedQuestionsRelatedCategoryConnection>
	related_questionConnection?: Maybe<FaqOutletContentRelatedQuestionsRelatedQuestionConnection>
}

export type FaqOutletContentRelatedQuestionsRelatedCategoryConnection = {
	__typename?: 'FaqOutletContentRelatedQuestionsRelatedCategoryConnection'
	edges?: Maybe<
		Array<Maybe<FaqOutletContentRelatedQuestionsRelatedCategoryEdge>>
	>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type FaqOutletContentRelatedQuestionsRelatedCategoryEdge = {
	__typename?: 'FaqOutletContentRelatedQuestionsRelatedCategoryEdge'
	node?: Maybe<FaqOutletContentRelatedQuestionsRelatedCategoryNode>
}

export type FaqOutletContentRelatedQuestionsRelatedCategoryNode = Category

export type FaqOutletContentRelatedQuestionsRelatedCategoryWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	category?: InputMaybe<CategoryWhere>
}

export type FaqOutletContentRelatedQuestionsRelatedQuestionConnection = {
	__typename?: 'FaqOutletContentRelatedQuestionsRelatedQuestionConnection'
	edges?: Maybe<
		Array<Maybe<FaqOutletContentRelatedQuestionsRelatedQuestionEdge>>
	>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type FaqOutletContentRelatedQuestionsRelatedQuestionEdge = {
	__typename?: 'FaqOutletContentRelatedQuestionsRelatedQuestionEdge'
	node?: Maybe<FaqOutletContentRelatedQuestionsRelatedQuestionNode>
}

export type FaqOutletContentRelatedQuestionsRelatedQuestionNode = Question

export type FaqOutletContentRelatedQuestionsRelatedQuestionWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type FaqOutletContentRelatedQuestionsWhere = {
	related_category?: InputMaybe<FaqOutletContentRelatedQuestionsRelatedCategoryWhere>
	related_category_exists?: InputMaybe<Scalars['Boolean']['input']>
	related_question?: InputMaybe<FaqOutletContentRelatedQuestionsRelatedQuestionWhere>
	related_question_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export type FaqOutletContentWhere = {
	related_questions?: InputMaybe<FaqOutletContentRelatedQuestionsWhere>
	related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type FaqWhere = {
	AND?: InputMaybe<Array<InputMaybe<FaqWhere>>>
	OR?: InputMaybe<Array<InputMaybe<FaqWhere>>>
	content?: InputMaybe<FaqContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<FaqOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type HomeAdditionalInfo = {
	__typename?: 'HomeAdditionalInfo'
	content?: Maybe<HomeAdditionalInfoContent>
	outlet_content?: Maybe<HomeAdditionalInfoOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type HomeAdditionalInfoContent = {
	__typename?: 'HomeAdditionalInfoContent'
	text?: Maybe<Scalars['String']['output']>
}

export type HomeAdditionalInfoContentWhere = {
	text?: InputMaybe<Scalars['String']['input']>
	text_exists?: InputMaybe<Scalars['Boolean']['input']>
	text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	text_ne?: InputMaybe<Scalars['String']['input']>
	text_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum HomeAdditionalInfoOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type HomeAdditionalInfoOutletContent = {
	__typename?: 'HomeAdditionalInfoOutletContent'
	text?: Maybe<Scalars['String']['output']>
}

export type HomeAdditionalInfoOutletContentWhere = {
	text?: InputMaybe<Scalars['String']['input']>
	text_exists?: InputMaybe<Scalars['Boolean']['input']>
	text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	text_ne?: InputMaybe<Scalars['String']['input']>
	text_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type HomeAdditionalInfoWhere = {
	AND?: InputMaybe<Array<InputMaybe<HomeAdditionalInfoWhere>>>
	OR?: InputMaybe<Array<InputMaybe<HomeAdditionalInfoWhere>>>
	content?: InputMaybe<HomeAdditionalInfoContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<HomeAdditionalInfoOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type HomepageAdditionalInfo = {
	__typename?: 'HomepageAdditionalInfo'
	content?: Maybe<HomepageAdditionalInfoContent>
	outlet_content?: Maybe<HomepageAdditionalInfoOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type HomepageAdditionalInfoContent = {
	__typename?: 'HomepageAdditionalInfoContent'
	label_key?: Maybe<Scalars['String']['output']>
}

export type HomepageAdditionalInfoContentWhere = {
	label_key?: InputMaybe<Scalars['String']['input']>
	label_key_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	label_key_ne?: InputMaybe<Scalars['String']['input']>
	label_key_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum HomepageAdditionalInfoOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type HomepageAdditionalInfoOutletContent = {
	__typename?: 'HomepageAdditionalInfoOutletContent'
	label_key?: Maybe<Scalars['String']['output']>
}

export type HomepageAdditionalInfoOutletContentWhere = {
	label_key?: InputMaybe<Scalars['String']['input']>
	label_key_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	label_key_ne?: InputMaybe<Scalars['String']['input']>
	label_key_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type HomepageAdditionalInfoWhere = {
	AND?: InputMaybe<Array<InputMaybe<HomepageAdditionalInfoWhere>>>
	OR?: InputMaybe<Array<InputMaybe<HomepageAdditionalInfoWhere>>>
	content?: InputMaybe<HomepageAdditionalInfoContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<HomepageAdditionalInfoOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Icon = {
	__typename?: 'Icon'
	code?: Maybe<Scalars['String']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export enum IconOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type IconWhere = {
	AND?: InputMaybe<Array<InputMaybe<IconWhere>>>
	OR?: InputMaybe<Array<InputMaybe<IconWhere>>>
	code?: InputMaybe<Scalars['String']['input']>
	code_exists?: InputMaybe<Scalars['Boolean']['input']>
	code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	code_ne?: InputMaybe<Scalars['String']['input']>
	code_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type InternalLinkButton = {
	__typename?: 'InternalLinkButton'
	content?: Maybe<InternalLinkButtonContent>
	description?: Maybe<Scalars['String']['output']>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type InternalLinkButtonContent = {
	__typename?: 'InternalLinkButtonContent'
	actions?: Maybe<Scalars['JSON']['output']>
	islegacy?: Maybe<Scalars['Boolean']['output']>
	label_key?: Maybe<Scalars['String']['output']>
	link?: Maybe<Link>
	link_in_new_tab?: Maybe<Scalars['Boolean']['output']>
	logged_link?: Maybe<Link>
	outlet_link?: Maybe<Link>
	outlet_logged_link?: Maybe<Link>
	type?: Maybe<Scalars['String']['output']>
}

export type InternalLinkButtonContentWhere = {
	actions?: InputMaybe<Scalars['JSON']['input']>
	actions_exists?: InputMaybe<Scalars['Boolean']['input']>
	islegacy?: InputMaybe<Scalars['Boolean']['input']>
	islegacy_exists?: InputMaybe<Scalars['Boolean']['input']>
	islegacy_ne?: InputMaybe<Scalars['Boolean']['input']>
	label_key?: InputMaybe<Scalars['String']['input']>
	label_key_exists?: InputMaybe<Scalars['Boolean']['input']>
	label_key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	label_key_ne?: InputMaybe<Scalars['String']['input']>
	label_key_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	link?: InputMaybe<LinkWhere>
	link_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_exists?: InputMaybe<Scalars['Boolean']['input']>
	link_in_new_tab_ne?: InputMaybe<Scalars['Boolean']['input']>
	logged_link?: InputMaybe<LinkWhere>
	logged_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	outlet_link?: InputMaybe<LinkWhere>
	outlet_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	outlet_logged_link?: InputMaybe<LinkWhere>
	outlet_logged_link_exists?: InputMaybe<Scalars['Boolean']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	type_exists?: InputMaybe<Scalars['Boolean']['input']>
	type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	type_ne?: InputMaybe<Scalars['String']['input']>
	type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum InternalLinkButtonOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type InternalLinkButtonWhere = {
	AND?: InputMaybe<Array<InputMaybe<InternalLinkButtonWhere>>>
	OR?: InputMaybe<Array<InputMaybe<InternalLinkButtonWhere>>>
	content?: InputMaybe<InternalLinkButtonContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description?: InputMaybe<Scalars['String']['input']>
	description_exists?: InputMaybe<Scalars['Boolean']['input']>
	description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description_ne?: InputMaybe<Scalars['String']['input']>
	description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Link = {
	__typename?: 'Link'
	href?: Maybe<Scalars['String']['output']>
	title?: Maybe<Scalars['String']['output']>
}

export type LinkWhere = {
	href?: InputMaybe<Scalars['String']['input']>
	href_exists?: InputMaybe<Scalars['Boolean']['input']>
	href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	href_ne?: InputMaybe<Scalars['String']['input']>
	href_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type Query = {
	__typename?: 'Query'
	all_assets?: Maybe<AllSysAsset>
	all_banner?: Maybe<AllBanner>
	all_button?: Maybe<AllButton>
	all_categoriesconfig?: Maybe<AllCategoriesconfig>
	all_category?: Maybe<AllCategory>
	all_contact_form_category?: Maybe<AllContactFormCategory>
	all_contact_form_configuration?: Maybe<AllContactFormConfiguration>
	all_contactlabel?: Maybe<AllContactlabel>
	all_contactlabelsconfig?: Maybe<AllContactlabelsconfig>
	all_external_link_button?: Maybe<AllExternalLinkButton>
	all_faq?: Maybe<AllFaq>
	all_home_additional_info?: Maybe<AllHomeAdditionalInfo>
	all_homepage_additional_info?: Maybe<AllHomepageAdditionalInfo>
	all_icon?: Maybe<AllIcon>
	all_internal_link_button?: Maybe<AllInternalLinkButton>
	all_question?: Maybe<AllQuestion>
	assets?: Maybe<SysAsset>
	banner?: Maybe<Banner>
	button?: Maybe<Button>
	categoriesconfig?: Maybe<Categoriesconfig>
	category?: Maybe<Category>
	contact_form_category?: Maybe<ContactFormCategory>
	contact_form_configuration?: Maybe<ContactFormConfiguration>
	contactlabel?: Maybe<Contactlabel>
	contactlabelsconfig?: Maybe<Contactlabelsconfig>
	external_link_button?: Maybe<ExternalLinkButton>
	faq?: Maybe<Faq>
	home_additional_info?: Maybe<HomeAdditionalInfo>
	homepage_additional_info?: Maybe<HomepageAdditionalInfo>
	icon?: Maybe<Icon>
	internal_link_button?: Maybe<InternalLinkButton>
	question?: Maybe<Question>
}

export type QueryAll_AssetsArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: InputMaybe<Scalars['String']['input']>
	order_by?: InputMaybe<Array<InputMaybe<SysAssetOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<SysAssetWhere>
}

export type QueryAll_BannerArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<BannerOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<BannerWhere>
}

export type QueryAll_ButtonArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<ButtonOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ButtonWhere>
}

export type QueryAll_CategoriesconfigArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<CategoriesconfigOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CategoriesconfigWhere>
}

export type QueryAll_CategoryArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<CategoryOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CategoryWhere>
}

export type QueryAll_Contact_Form_CategoryArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<ContactFormCategoryOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ContactFormCategoryWhere>
}

export type QueryAll_Contact_Form_ConfigurationArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<ContactFormConfigurationOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ContactFormConfigurationWhere>
}

export type QueryAll_ContactlabelArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<ContactlabelOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ContactlabelWhere>
}

export type QueryAll_ContactlabelsconfigArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<ContactlabelsconfigOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ContactlabelsconfigWhere>
}

export type QueryAll_External_Link_ButtonArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<ExternalLinkButtonOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ExternalLinkButtonWhere>
}

export type QueryAll_FaqArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<FaqOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<FaqWhere>
}

export type QueryAll_Home_Additional_InfoArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<HomeAdditionalInfoOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<HomeAdditionalInfoWhere>
}

export type QueryAll_Homepage_Additional_InfoArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<HomepageAdditionalInfoOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<HomepageAdditionalInfoWhere>
}

export type QueryAll_IconArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<IconOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<IconWhere>
}

export type QueryAll_Internal_Link_ButtonArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<InternalLinkButtonOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<InternalLinkButtonWhere>
}

export type QueryAll_QuestionArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	limit?: InputMaybe<Scalars['Int']['input']>
	locale?: Scalars['String']['input']
	order_by?: InputMaybe<Array<InputMaybe<QuestionOrderBy>>>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<QuestionWhere>
}

export type QueryAssetsArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: InputMaybe<Scalars['String']['input']>
	uid: Scalars['String']['input']
}

export type QueryBannerArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryButtonArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryCategoriesconfigArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryCategoryArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryContact_Form_CategoryArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryContact_Form_ConfigurationArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryContactlabelArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryContactlabelsconfigArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryExternal_Link_ButtonArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryFaqArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryHome_Additional_InfoArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryHomepage_Additional_InfoArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryIconArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryInternal_Link_ButtonArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type QueryQuestionArgs = {
	fallback_locale?: InputMaybe<Scalars['Boolean']['input']>
	locale?: Scalars['String']['input']
	uid: Scalars['String']['input']
}

export type Question = {
	__typename?: 'Question'
	content?: Maybe<QuestionContent>
	outlet_content?: Maybe<QuestionOutletContent>
	system?: Maybe<EntrySystemField>
	title?: Maybe<Scalars['String']['output']>
}

export type QuestionContent = {
	__typename?: 'QuestionContent'
	answers?: Maybe<Array<Maybe<QuestionContentAnswers>>>
	common_related_questionsConnection?: Maybe<QuestionContentCommonRelatedQuestionsConnection>
	is_sustainable?: Maybe<Scalars['Boolean']['output']>
	question?: Maybe<Scalars['String']['output']>
	related_questionsConnection?: Maybe<QuestionContentRelatedQuestionsConnection>
}

export type QuestionContentCommon_Related_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionContentRelated_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionContentAnswers = {
	__typename?: 'QuestionContentAnswers'
	buttonsConnection?: Maybe<QuestionContentAnswersButtonsConnection>
	text?: Maybe<Scalars['String']['output']>
}

export type QuestionContentAnswersButtonsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionContentAnswersButtonsConnection = {
	__typename?: 'QuestionContentAnswersButtonsConnection'
	edges?: Maybe<Array<Maybe<QuestionContentAnswersButtonsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type QuestionContentAnswersButtonsEdge = {
	__typename?: 'QuestionContentAnswersButtonsEdge'
	node?: Maybe<QuestionContentAnswersButtonsNode>
}

export type QuestionContentAnswersButtonsNode =
	| Button
	| ExternalLinkButton
	| InternalLinkButton

export type QuestionContentAnswersButtonsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	button?: InputMaybe<ButtonWhere>
	external_link_button?: InputMaybe<ExternalLinkButtonWhere>
	internal_link_button?: InputMaybe<InternalLinkButtonWhere>
}

export type QuestionContentAnswersWhere = {
	buttons?: InputMaybe<QuestionContentAnswersButtonsWhere>
	buttons_count?: InputMaybe<Scalars['Int']['input']>
	buttons_exists?: InputMaybe<Scalars['Boolean']['input']>
	text?: InputMaybe<Scalars['String']['input']>
	text_exists?: InputMaybe<Scalars['Boolean']['input']>
	text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	text_ne?: InputMaybe<Scalars['String']['input']>
	text_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QuestionContentCommonRelatedQuestionsConnection = {
	__typename?: 'QuestionContentCommonRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<QuestionContentCommonRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type QuestionContentCommonRelatedQuestionsEdge = {
	__typename?: 'QuestionContentCommonRelatedQuestionsEdge'
	node?: Maybe<QuestionContentCommonRelatedQuestionsNode>
}

export type QuestionContentCommonRelatedQuestionsNode = Question

export type QuestionContentCommonRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type QuestionContentRelatedQuestionsConnection = {
	__typename?: 'QuestionContentRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<QuestionContentRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type QuestionContentRelatedQuestionsEdge = {
	__typename?: 'QuestionContentRelatedQuestionsEdge'
	node?: Maybe<QuestionContentRelatedQuestionsNode>
}

export type QuestionContentRelatedQuestionsNode = Question

export type QuestionContentRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type QuestionContentWhere = {
	answers?: InputMaybe<QuestionContentAnswersWhere>
	answers_exists?: InputMaybe<Scalars['Boolean']['input']>
	common_related_questions?: InputMaybe<QuestionContentCommonRelatedQuestionsWhere>
	common_related_questions_count?: InputMaybe<Scalars['Int']['input']>
	common_related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	is_sustainable?: InputMaybe<Scalars['Boolean']['input']>
	is_sustainable_exists?: InputMaybe<Scalars['Boolean']['input']>
	is_sustainable_ne?: InputMaybe<Scalars['Boolean']['input']>
	question?: InputMaybe<Scalars['String']['input']>
	question_exists?: InputMaybe<Scalars['Boolean']['input']>
	question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	question_ne?: InputMaybe<Scalars['String']['input']>
	question_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	related_questions?: InputMaybe<QuestionContentRelatedQuestionsWhere>
	related_questions_count?: InputMaybe<Scalars['Int']['input']>
	related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export enum QuestionOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export type QuestionOutletContent = {
	__typename?: 'QuestionOutletContent'
	answers?: Maybe<Array<Maybe<QuestionOutletContentAnswers>>>
	common_related_questionsConnection?: Maybe<QuestionOutletContentCommonRelatedQuestionsConnection>
	content_overwrite_selector?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	is_sustainable?: Maybe<Scalars['Boolean']['output']>
	question?: Maybe<Scalars['String']['output']>
	related_questionsConnection?: Maybe<QuestionOutletContentRelatedQuestionsConnection>
}

export type QuestionOutletContentCommon_Related_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionOutletContentRelated_QuestionsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionOutletContentAnswers = {
	__typename?: 'QuestionOutletContentAnswers'
	buttonsConnection?: Maybe<QuestionOutletContentAnswersButtonsConnection>
	text?: Maybe<Scalars['String']['output']>
}

export type QuestionOutletContentAnswersButtonsConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionOutletContentAnswersButtonsConnection = {
	__typename?: 'QuestionOutletContentAnswersButtonsConnection'
	edges?: Maybe<Array<Maybe<QuestionOutletContentAnswersButtonsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type QuestionOutletContentAnswersButtonsEdge = {
	__typename?: 'QuestionOutletContentAnswersButtonsEdge'
	node?: Maybe<QuestionOutletContentAnswersButtonsNode>
}

export type QuestionOutletContentAnswersButtonsNode =
	| Button
	| ExternalLinkButton
	| InternalLinkButton

export type QuestionOutletContentAnswersButtonsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	button?: InputMaybe<ButtonWhere>
	external_link_button?: InputMaybe<ExternalLinkButtonWhere>
	internal_link_button?: InputMaybe<InternalLinkButtonWhere>
}

export type QuestionOutletContentAnswersWhere = {
	buttons?: InputMaybe<QuestionOutletContentAnswersButtonsWhere>
	buttons_count?: InputMaybe<Scalars['Int']['input']>
	buttons_exists?: InputMaybe<Scalars['Boolean']['input']>
	text?: InputMaybe<Scalars['String']['input']>
	text_exists?: InputMaybe<Scalars['Boolean']['input']>
	text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	text_ne?: InputMaybe<Scalars['String']['input']>
	text_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QuestionOutletContentCommonRelatedQuestionsConnection = {
	__typename?: 'QuestionOutletContentCommonRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<QuestionOutletContentCommonRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type QuestionOutletContentCommonRelatedQuestionsEdge = {
	__typename?: 'QuestionOutletContentCommonRelatedQuestionsEdge'
	node?: Maybe<QuestionOutletContentCommonRelatedQuestionsNode>
}

export type QuestionOutletContentCommonRelatedQuestionsNode = Question

export type QuestionOutletContentCommonRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type QuestionOutletContentRelatedQuestionsConnection = {
	__typename?: 'QuestionOutletContentRelatedQuestionsConnection'
	edges?: Maybe<Array<Maybe<QuestionOutletContentRelatedQuestionsEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type QuestionOutletContentRelatedQuestionsEdge = {
	__typename?: 'QuestionOutletContentRelatedQuestionsEdge'
	node?: Maybe<QuestionOutletContentRelatedQuestionsNode>
}

export type QuestionOutletContentRelatedQuestionsNode = Question

export type QuestionOutletContentRelatedQuestionsWhere = {
	MATCH?: InputMaybe<EvalReferenceEnum>
	question?: InputMaybe<QuestionWhere>
}

export type QuestionOutletContentWhere = {
	answers?: InputMaybe<QuestionOutletContentAnswersWhere>
	answers_exists?: InputMaybe<Scalars['Boolean']['input']>
	common_related_questions?: InputMaybe<QuestionOutletContentCommonRelatedQuestionsWhere>
	common_related_questions_count?: InputMaybe<Scalars['Int']['input']>
	common_related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
	content_overwrite_selector?: InputMaybe<Scalars['String']['input']>
	content_overwrite_selector_exists?: InputMaybe<Scalars['Boolean']['input']>
	content_overwrite_selector_in?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	content_overwrite_selector_ne?: InputMaybe<Scalars['String']['input']>
	content_overwrite_selector_nin?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	is_sustainable?: InputMaybe<Scalars['Boolean']['input']>
	is_sustainable_exists?: InputMaybe<Scalars['Boolean']['input']>
	is_sustainable_ne?: InputMaybe<Scalars['Boolean']['input']>
	question?: InputMaybe<Scalars['String']['input']>
	question_exists?: InputMaybe<Scalars['Boolean']['input']>
	question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	question_ne?: InputMaybe<Scalars['String']['input']>
	question_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	related_questions?: InputMaybe<QuestionOutletContentRelatedQuestionsWhere>
	related_questions_count?: InputMaybe<Scalars['Int']['input']>
	related_questions_exists?: InputMaybe<Scalars['Boolean']['input']>
}

export type QuestionWhere = {
	AND?: InputMaybe<Array<InputMaybe<QuestionWhere>>>
	OR?: InputMaybe<Array<InputMaybe<QuestionWhere>>>
	content?: InputMaybe<QuestionContentWhere>
	content_exists?: InputMaybe<Scalars['Boolean']['input']>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_by?: InputMaybe<Scalars['String']['input']>
	created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	created_by_ne?: InputMaybe<Scalars['String']['input']>
	created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale?: InputMaybe<Scalars['String']['input']>
	locale_exists?: InputMaybe<Scalars['Boolean']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	outlet_content?: InputMaybe<QuestionOutletContentWhere>
	outlet_content_exists?: InputMaybe<Scalars['Boolean']['input']>
	publish_details?: InputMaybe<SystemPublishDetailsWhere>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_by?: InputMaybe<Scalars['String']['input']>
	updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_by_ne?: InputMaybe<Scalars['String']['input']>
	updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	version?: InputMaybe<Scalars['Int']['input']>
	version_gt?: InputMaybe<Scalars['Int']['input']>
	version_gte?: InputMaybe<Scalars['Int']['input']>
	version_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	version_lt?: InputMaybe<Scalars['Int']['input']>
	version_lte?: InputMaybe<Scalars['Int']['input']>
	version_ne?: InputMaybe<Scalars['Int']['input']>
	version_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type SysAsset = {
	__typename?: 'SysAsset'
	content_type?: Maybe<Scalars['String']['output']>
	description?: Maybe<Scalars['String']['output']>
	dimension?: Maybe<SysAssetDimension>
	file_size?: Maybe<Scalars['Int']['output']>
	filename?: Maybe<Scalars['String']['output']>
	metadata?: Maybe<Scalars['JSON']['output']>
	parent_uid?: Maybe<Scalars['String']['output']>
	permanent_url?: Maybe<Scalars['String']['output']>
	system?: Maybe<SysAssetSystemField>
	title?: Maybe<Scalars['String']['output']>
	unique_identifier?: Maybe<Scalars['String']['output']>
	url?: Maybe<Scalars['String']['output']>
}

export type SysAssetUrlArgs = {
	transform?: InputMaybe<SysAssetTransformUrl>
}

/** WEBP images are usually lower in size and have good quality. */
export enum SysAssetAutoValues {
	Webp = 'WEBP',
}

export type SysAssetDimension = {
	__typename?: 'SysAssetDimension'
	height?: Maybe<Scalars['Int']['output']>
	width?: Maybe<Scalars['Int']['output']>
}

export type SysAssetDimensionWhere = {
	height?: InputMaybe<Scalars['Int']['input']>
	height_exists?: InputMaybe<Scalars['Boolean']['input']>
	height_gt?: InputMaybe<Scalars['Int']['input']>
	height_gte?: InputMaybe<Scalars['Int']['input']>
	height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	height_lt?: InputMaybe<Scalars['Int']['input']>
	height_lte?: InputMaybe<Scalars['Int']['input']>
	height_ne?: InputMaybe<Scalars['Int']['input']>
	height_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	width?: InputMaybe<Scalars['Int']['input']>
	width_exists?: InputMaybe<Scalars['Boolean']['input']>
	width_gt?: InputMaybe<Scalars['Int']['input']>
	width_gte?: InputMaybe<Scalars['Int']['input']>
	width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	width_lt?: InputMaybe<Scalars['Int']['input']>
	width_lte?: InputMaybe<Scalars['Int']['input']>
	width_ne?: InputMaybe<Scalars['Int']['input']>
	width_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export enum SysAssetDisableValues {
	/** UPSCALE is always enabled, in which the image is upscaled if the output image (by specifying the width or height) is bigger than the source image */
	Upscale = 'UPSCALE',
}

/** This parameter allows an image to be downloaded or rendered on page */
export enum SysAssetDispositionValues {
	/** Allows to download an image */
	Attachment = 'ATTACHMENT',
	/** Allows an image to be rendered on page */
	Inline = 'INLINE',
}

export enum SysAssetFitValues {
	Bounds = 'BOUNDS',
	Crop = 'CROP',
}

export enum SysAssetImageFormats {
	/** Convert an image to GIF format */
	Gif = 'GIF',
	/** Convert an image to JPEG format */
	Jpg = 'JPG',
	/** A Progressive JPEG is an image file created using a compression method that displays higher detail in progression */
	Pjpg = 'PJPG',
	/** Convert an image to PNG format */
	Png = 'PNG',
	/** WEBP images are usually lower in size and have good quality */
	Webp = 'WEBP',
	/** WEBP Lossless format */
	Webpll = 'WEBPLL',
	/** WEBP Lossy format */
	Webply = 'WEBPLY',
}

export enum SysAssetOrderBy {
	CreatedAtAsc = 'created_at_ASC',
	CreatedAtDesc = 'created_at_DESC',
	UpdatedAtAsc = 'updated_at_ASC',
	UpdatedAtDesc = 'updated_at_DESC',
}

export enum SysAssetOrientValues {
	/** Flip image horizontally and vertically */
	Both = 'BOTH',
	/** Set image to default */
	Default = 'DEFAULT',
	/** Flip image horizontally */
	Horizontally = 'HORIZONTALLY',
	/** Flip image horizontally and then rotate 90 degrees towards left */
	Rotate90Left = 'ROTATE90LEFT',
	/** Rotate image 90 degrees towards right */
	Rotate90Right = 'ROTATE90RIGHT',
	/** Flip image vertically */
	Vertically = 'VERTICALLY',
}

/** The overlay_align parameter allows you to put one image on top of another */
export enum SysAssetOverlayAlignValues {
	/** Align the overlay image to the bottom of the actual image */
	Bottom = 'BOTTOM',
	/** Align the overlay image to the center (horizontally) of the actual image */
	Center = 'CENTER',
	/** Align the overlay image to the left of the actual image */
	Left = 'LEFT',
	/** Align the overlay image to the middle (vertically) of the actual image */
	Middle = 'MIDDLE',
	/** Align the overlay image to the right of the actual image */
	Right = 'RIGHT',
	/** Align the overlay image to the top of the actual image */
	Top = 'TOP',
}

export enum SysAssetOverlayRepeatValues {
	/** Horizontal and vertical repetition */
	Both = 'BOTH',
	/** Horizontal repetition */
	X = 'X',
	/** Vertical repetition */
	Y = 'Y',
}

export type SysAssetSystemField = {
	__typename?: 'SysAssetSystemField'
	branch?: Maybe<Scalars['String']['output']>
	content_type_uid?: Maybe<Scalars['String']['output']>
	created_at?: Maybe<Scalars['DateTime']['output']>
	created_by?: Maybe<Scalars['String']['output']>
	extensionConnection?: Maybe<SysExtensionConnection>
	publish_details?: Maybe<SystemPublishDetails>
	tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	uid?: Maybe<Scalars['String']['output']>
	updated_at?: Maybe<Scalars['DateTime']['output']>
	updated_by?: Maybe<Scalars['String']['output']>
	version?: Maybe<Scalars['Int']['output']>
}

export type SysAssetSystemFieldExtensionConnectionArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
}

export type SysAssetTransformUrl = {
	/** When the auto parameter is set to webp, it enables WebP image support. WebP images have higher compression rate with minimum loss of quality. */
	auto?: InputMaybe<SysAssetAutoValues>
	/** The bg-color parameter lets you set a backgroud color for the given image. This is useful when applying padding or for replacing the transparent pixels of an image */
	bg_color?: InputMaybe<Scalars['String']['input']>
	crop?: InputMaybe<Scalars['String']['input']>
	/** The disable parameter disables the functionality that is enabled by default */
	disable?: InputMaybe<SysAssetDisableValues>
	/** The disposition parameter lets you allow image to download or render.  */
	disposition?: InputMaybe<SysAssetDispositionValues>
	/** The dpr parameter lets you deliver images with appropriate size to devices that come with a defined device pixel ratio. The device pixel ratio of any device determines the screen resolution that its CSS would interpret */
	dpr?: InputMaybe<Scalars['String']['input']>
	/** Fit parameter enables you to fit the given image properly within the specified height and width */
	fit?: InputMaybe<SysAssetFitValues>
	/** Format parameter lets you converts a given image from one format to another */
	format?: InputMaybe<SysAssetImageFormats>
	height?: InputMaybe<Scalars['String']['input']>
	/** The orient parameter lets you control the cardinal orientation of the given image */
	orient?: InputMaybe<SysAssetOrientValues>
	overlay?: InputMaybe<Scalars['String']['input']>
	overlay_align?: InputMaybe<SysAssetOverlayAlignValues>
	/** The value for this parameter can be set in pixels or percentage. For pixel value, use any whole number between 1 and 8192. For percentage value, use any decimal number between 0.0 and 0.99. When height is defined in percentage, it relative to the output image */
	overlay_height?: InputMaybe<Scalars['String']['input']>
	/** The overlay_repeat parameter lets you define how the overlay image will be repeated on the given image */
	overlay_repeat?: InputMaybe<SysAssetOverlayRepeatValues>
	/** The value for this parameter can be set in pixels or percentage. For pixel value, use any whole number between 1 and 8192. For percentage value, use any decimal number between 0.0 and 0.99. When width is defined in percentage, it is relative to the output image */
	overlay_width?: InputMaybe<Scalars['String']['input']>
	/** This parameter lets you add extra pixels to the edges of an image. You can specify values for top, right, bottom, and left padding for an image */
	pad?: InputMaybe<Scalars['String']['input']>
	quality?: InputMaybe<Scalars['Int']['input']>
	trim?: InputMaybe<Scalars['String']['input']>
	width?: InputMaybe<Scalars['String']['input']>
}

export type SysAssetWhere = {
	AND?: InputMaybe<Array<InputMaybe<SysAssetWhere>>>
	OR?: InputMaybe<Array<InputMaybe<SysAssetWhere>>>
	created_at?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	created_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	created_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	created_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	description?: InputMaybe<Scalars['String']['input']>
	description_exists?: InputMaybe<Scalars['Boolean']['input']>
	description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	description_ne?: InputMaybe<Scalars['String']['input']>
	description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	dimension?: InputMaybe<SysAssetDimensionWhere>
	dimension_exists?: InputMaybe<Scalars['Boolean']['input']>
	file_size?: InputMaybe<Scalars['Int']['input']>
	file_size_exists?: InputMaybe<Scalars['Boolean']['input']>
	file_size_gt?: InputMaybe<Scalars['Int']['input']>
	file_size_gte?: InputMaybe<Scalars['Int']['input']>
	file_size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	file_size_lt?: InputMaybe<Scalars['Int']['input']>
	file_size_lte?: InputMaybe<Scalars['Int']['input']>
	file_size_ne?: InputMaybe<Scalars['Int']['input']>
	file_size_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
	filename?: InputMaybe<Scalars['String']['input']>
	filename_exists?: InputMaybe<Scalars['Boolean']['input']>
	filename_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	filename_ne?: InputMaybe<Scalars['String']['input']>
	filename_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	parent_uid?: InputMaybe<Scalars['String']['input']>
	parent_uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	parent_uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	parent_uid_ne?: InputMaybe<Scalars['String']['input']>
	parent_uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags?: InputMaybe<Scalars['String']['input']>
	tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title?: InputMaybe<Scalars['String']['input']>
	title_exists?: InputMaybe<Scalars['Boolean']['input']>
	title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	title_ne?: InputMaybe<Scalars['String']['input']>
	title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid?: InputMaybe<Scalars['String']['input']>
	uid_exists?: InputMaybe<Scalars['Boolean']['input']>
	uid_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	uid_ne?: InputMaybe<Scalars['String']['input']>
	uid_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	updated_at?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>
	updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	url?: InputMaybe<Scalars['String']['input']>
	url_exists?: InputMaybe<Scalars['Boolean']['input']>
	url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	url_ne?: InputMaybe<Scalars['String']['input']>
	url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type SysExtensionConnection = {
	__typename?: 'SysExtensionConnection'
	edges?: Maybe<Array<Maybe<SysExtensionEdge>>>
	totalCount?: Maybe<Scalars['Int']['output']>
}

export type SysExtensionEdge = {
	__typename?: 'SysExtensionEdge'
	node?: Maybe<SysMetadata>
}

export type SysMetadata = {
	__typename?: 'SysMetadata'
	extension_uid?: Maybe<Scalars['String']['output']>
	metadata?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>
}

export type SystemPublishDetails = {
	__typename?: 'SystemPublishDetails'
	environment?: Maybe<Scalars['String']['output']>
	locale?: Maybe<Scalars['String']['output']>
	time?: Maybe<Scalars['DateTime']['output']>
	user?: Maybe<Scalars['String']['output']>
}

export type SystemPublishDetailsWhere = {
	locale?: InputMaybe<Scalars['String']['input']>
	locale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locale_ne?: InputMaybe<Scalars['String']['input']>
	locale_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	time?: InputMaybe<Scalars['DateTime']['input']>
	time_gt?: InputMaybe<Scalars['DateTime']['input']>
	time_gte?: InputMaybe<Scalars['DateTime']['input']>
	time_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	time_lt?: InputMaybe<Scalars['DateTime']['input']>
	time_lte?: InputMaybe<Scalars['DateTime']['input']>
	time_ne?: InputMaybe<Scalars['DateTime']['input']>
	time_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
	user?: InputMaybe<Scalars['String']['input']>
	user_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	user_ne?: InputMaybe<Scalars['String']['input']>
	user_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type GetBannerListQueryVariables = Exact<{
	locale: Scalars['String']['input']
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetBannerListQuery = {
	__typename?: 'Query'
	allCommBanners?: {
		__typename?: 'AllBanner'
		items?: Array<{
			__typename?: 'Banner'
			content?: {
				__typename?: 'BannerContent'
				subtitle?: string | null
				title?: string | null
			} | null
			system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
		} | null> | null
	} | null
}

export type CategoriesFragment = {
	__typename?: 'CategoriesconfigContent'
	relatedCategories?: {
		__typename?: 'CategoriesconfigContentRelatedCategoriesConnection'
		total?: number | null
		edges?: Array<{
			__typename?: 'CategoriesconfigContentRelatedCategoriesEdge'
			node?: {
				__typename?: 'Category'
				key?: string | null
				content?: {
					__typename?: 'CategoryContent'
					title?: string | null
					icon?: {
						__typename?: 'CategoryContentIconConnection'
						edges?: Array<{
							__typename?: 'CategoryContentIconEdge'
							node?: { __typename?: 'Icon'; title?: string | null } | null
						} | null> | null
					} | null
				} | null
				outletContent?: {
					__typename?: 'CategoryOutletContent'
					title?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					icon?: {
						__typename?: 'CategoryOutletContentIconConnection'
						edges?: Array<{
							__typename?: 'CategoryOutletContentIconEdge'
							node?: { __typename?: 'Icon'; title?: string | null } | null
						} | null> | null
					} | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'CategoriesFragment' }

export type OutletCategoriesFragment = {
	__typename?: 'CategoriesconfigOutletContent'
	relatedCategories?: {
		__typename?: 'CategoriesconfigOutletContentRelatedCategoriesConnection'
		total?: number | null
		edges?: Array<{
			__typename?: 'CategoriesconfigOutletContentRelatedCategoriesEdge'
			node?: {
				__typename?: 'Category'
				key?: string | null
				content?: {
					__typename?: 'CategoryContent'
					title?: string | null
					icon?: {
						__typename?: 'CategoryContentIconConnection'
						edges?: Array<{
							__typename?: 'CategoryContentIconEdge'
							node?: { __typename?: 'Icon'; title?: string | null } | null
						} | null> | null
					} | null
				} | null
				outletContent?: {
					__typename?: 'CategoryOutletContent'
					title?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					icon?: {
						__typename?: 'CategoryOutletContentIconConnection'
						edges?: Array<{
							__typename?: 'CategoryOutletContentIconEdge'
							node?: { __typename?: 'Icon'; title?: string | null } | null
						} | null> | null
					} | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'OutletCategoriesFragment' }

export type GetCategoryListQueryVariables = Exact<{
	locale: Scalars['String']['input']
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetCategoryListQuery = {
	__typename?: 'Query'
	allCategory?: {
		__typename?: 'AllCategoriesconfig'
		items?: Array<{
			__typename?: 'Categoriesconfig'
			content?:
				| ({ __typename?: 'CategoriesconfigContent' } & {
						' $fragmentRefs'?: { CategoriesFragment: CategoriesFragment }
				  })
				| null
			outletContent?:
				| ({ __typename?: 'CategoriesconfigOutletContent' } & {
						' $fragmentRefs'?: {
							OutletCategoriesFragment: OutletCategoriesFragment
						}
				  })
				| null
		} | null> | null
	} | null
}

export type ContactMethodsFragment = {
	__typename?: 'ContactlabelsconfigContent'
	additionalInfo?: string | null
	relatedContactLabels?: {
		__typename?: 'ContactlabelsconfigContentRelatedContactLabelsConnection'
		edges?: Array<{
			__typename?: 'ContactlabelsconfigContentRelatedContactLabelsEdge'
			node?: {
				__typename?: 'Contactlabel'
				content?: {
					__typename?: 'ContactlabelContent'
					title?: string | null
					type?: string | null
					description?: string | null
					analyticLabel?: string | null
					linkInNewTab?: boolean | null
					link?: {
						__typename?: 'Link'
						href?: string | null
						title?: string | null
					} | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'ContactMethodsFragment' }

export type OutletContactMethodsFragment = {
	__typename?: 'ContactlabelsconfigOutletContent'
	additionalInfo?: string | null
	relatedContactLabels?: {
		__typename?: 'ContactlabelsconfigOutletContentRelatedContactLabelsConnection'
		edges?: Array<{
			__typename?: 'ContactlabelsconfigOutletContentRelatedContactLabelsEdge'
			node?: {
				__typename?: 'Contactlabel'
				content?: {
					__typename?: 'ContactlabelContent'
					title?: string | null
					type?: string | null
					description?: string | null
					analyticLabel?: string | null
					linkInNewTab?: boolean | null
					link?: {
						__typename?: 'Link'
						href?: string | null
						title?: string | null
					} | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'OutletContactMethodsFragment' }

export type GetContactLabelsListQueryVariables = Exact<{
	locale: Scalars['String']['input']
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetContactLabelsListQuery = {
	__typename?: 'Query'
	allContactLabels?: {
		__typename?: 'AllContactlabelsconfig'
		items?: Array<{
			__typename?: 'Contactlabelsconfig'
			content?:
				| ({ __typename?: 'ContactlabelsconfigContent' } & {
						' $fragmentRefs'?: {
							ContactMethodsFragment: ContactMethodsFragment
						}
				  })
				| null
			outletContent?:
				| ({ __typename?: 'ContactlabelsconfigOutletContent' } & {
						' $fragmentRefs'?: {
							OutletContactMethodsFragment: OutletContactMethodsFragment
						}
				  })
				| null
		} | null> | null
	} | null
}

export type GetHomepageAdditionalInfoQueryVariables = Exact<{
	locale: Scalars['String']['input']
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetHomepageAdditionalInfoQuery = {
	__typename?: 'Query'
	allHomepageAdditionalInfo?: {
		__typename?: 'AllHomepageAdditionalInfo'
		items?: Array<{
			__typename?: 'HomepageAdditionalInfo'
			content?: {
				__typename?: 'HomepageAdditionalInfoContent'
				labelKey?: string | null
			} | null
			outletContent?: {
				__typename?: 'HomepageAdditionalInfoOutletContent'
				labelKey?: string | null
			} | null
		} | null> | null
	} | null
}

export type FaqContentFragment = {
	__typename?: 'FaqContent'
	title?: string | null
	relatedQuestions?: Array<{
		__typename?: 'FaqContentRelatedQuestions'
		relatedCategory?: {
			__typename?: 'FaqContentRelatedQuestionsRelatedCategoryConnection'
			edges?: Array<{
				__typename?: 'FaqContentRelatedQuestionsRelatedCategoryEdge'
				node?: { __typename?: 'Category'; title?: string | null } | null
			} | null> | null
		} | null
		relatedQuestion?: {
			__typename?: 'FaqContentRelatedQuestionsRelatedQuestionConnection'
			edges?: Array<{
				__typename?: 'FaqContentRelatedQuestionsRelatedQuestionEdge'
				node?: {
					__typename?: 'Question'
					questionKey?: string | null
					system?: {
						__typename?: 'EntrySystemField'
						uid?: string | null
					} | null
					content?: {
						__typename?: 'QuestionContent'
						question?: string | null
						isSustainable?: boolean | null
					} | null
					outletContent?: {
						__typename?: 'QuestionOutletContent'
						question?: string | null
						contentOverwriteSelector?: Array<string | null> | null
						isSustainable?: boolean | null
					} | null
				} | null
			} | null> | null
		} | null
	} | null> | null
} & { ' $fragmentName'?: 'FaqContentFragment' }

export type FaqOutletContentFragment = {
	__typename?: 'FaqOutletContent'
	title?: string | null
	relatedQuestions?: Array<{
		__typename?: 'FaqOutletContentRelatedQuestions'
		relatedCategory?: {
			__typename?: 'FaqOutletContentRelatedQuestionsRelatedCategoryConnection'
			edges?: Array<{
				__typename?: 'FaqOutletContentRelatedQuestionsRelatedCategoryEdge'
				node?: { __typename?: 'Category'; title?: string | null } | null
			} | null> | null
		} | null
		relatedQuestion?: {
			__typename?: 'FaqOutletContentRelatedQuestionsRelatedQuestionConnection'
			edges?: Array<{
				__typename?: 'FaqOutletContentRelatedQuestionsRelatedQuestionEdge'
				node?: {
					__typename?: 'Question'
					questionKey?: string | null
					system?: {
						__typename?: 'EntrySystemField'
						uid?: string | null
					} | null
					content?: {
						__typename?: 'QuestionContent'
						question?: string | null
						isSustainable?: boolean | null
					} | null
					outletContent?: {
						__typename?: 'QuestionOutletContent'
						question?: string | null
						contentOverwriteSelector?: Array<string | null> | null
						isSustainable?: boolean | null
					} | null
				} | null
			} | null> | null
		} | null
	} | null> | null
} & { ' $fragmentName'?: 'FaqOutletContentFragment' }

export type CategoryContentFragment = {
	__typename?: 'CategoryContent'
	title?: string | null
	relatedQuestions?: {
		__typename?: 'CategoryContentRelatedQuestionsConnection'
		totalCount?: number | null
		edges?: Array<{
			__typename?: 'CategoryContentRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
			} | null
		} | null> | null
	} | null
	commonRelatedQuestions?: {
		__typename?: 'CategoryContentCommonRelatedQuestionsConnection'
		totalCount?: number | null
		edges?: Array<{
			__typename?: 'CategoryContentCommonRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'CategoryContentFragment' }

export type CategoryOutletContentFragment = {
	__typename?: 'CategoryOutletContent'
	title?: string | null
	relatedQuestions?: {
		__typename?: 'CategoryOutletContentRelatedQuestionsConnection'
		totalCount?: number | null
		edges?: Array<{
			__typename?: 'CategoryOutletContentRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
			} | null
		} | null> | null
	} | null
	commonRelatedQuestions?: {
		__typename?: 'CategoryOutletContentCommonRelatedQuestionsConnection'
		totalCount?: number | null
		edges?: Array<{
			__typename?: 'CategoryOutletContentCommonRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'CategoryOutletContentFragment' }

export type QuestionContentFragment = {
	__typename?: 'QuestionContent'
	question?: string | null
	isSustainable?: boolean | null
	answers?: Array<{
		__typename?: 'QuestionContentAnswers'
		text?: string | null
		buttons?: {
			__typename?: 'QuestionContentAnswersButtonsConnection'
			totalButtons?: number | null
			edges?: Array<{
				__typename?: 'QuestionContentAnswersButtonsEdge'
				node?:
					| { __typename?: 'Button' }
					| {
							__typename?: 'ExternalLinkButton'
							buttonKey?: string | null
							content?: {
								__typename?: 'ExternalLinkButtonContent'
								actions?: any | null
								labelKey?: string | null
								linkInNewTab?: boolean | null
								link?: { __typename?: 'Link'; href?: string | null } | null
								loggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLoggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
							} | null
					  }
					| {
							__typename?: 'InternalLinkButton'
							buttonKey?: string | null
							content?: {
								__typename?: 'InternalLinkButtonContent'
								actions?: any | null
								labelKey?: string | null
								linkInNewTab?: boolean | null
								isLegacy?: boolean | null
								link?: { __typename?: 'Link'; href?: string | null } | null
								loggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLoggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
							} | null
					  }
					| null
			} | null> | null
		} | null
	} | null> | null
	relatedQuestions?: {
		__typename?: 'QuestionContentRelatedQuestionsConnection'
		totalRelatedQuestions?: number | null
		edges?: Array<{
			__typename?: 'QuestionContentRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
	commonRelatedQuestions?: {
		__typename?: 'QuestionContentCommonRelatedQuestionsConnection'
		totalCommonRelatedQuestions?: number | null
		edges?: Array<{
			__typename?: 'QuestionContentCommonRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'QuestionContentFragment' }

export type QuestionOutletContentFragment = {
	__typename?: 'QuestionOutletContent'
	question?: string | null
	isSustainable?: boolean | null
	answers?: Array<{
		__typename?: 'QuestionOutletContentAnswers'
		text?: string | null
		buttons?: {
			__typename?: 'QuestionOutletContentAnswersButtonsConnection'
			totalButtons?: number | null
			edges?: Array<{
				__typename?: 'QuestionOutletContentAnswersButtonsEdge'
				node?:
					| { __typename?: 'Button' }
					| {
							__typename?: 'ExternalLinkButton'
							buttonKey?: string | null
							content?: {
								__typename?: 'ExternalLinkButtonContent'
								actions?: any | null
								labelKey?: string | null
								linkInNewTab?: boolean | null
								link?: { __typename?: 'Link'; href?: string | null } | null
								loggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLoggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
							} | null
					  }
					| {
							__typename?: 'InternalLinkButton'
							buttonKey?: string | null
							content?: {
								__typename?: 'InternalLinkButtonContent'
								actions?: any | null
								labelKey?: string | null
								linkInNewTab?: boolean | null
								isLegacy?: boolean | null
								link?: { __typename?: 'Link'; href?: string | null } | null
								loggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
								outletLoggedLink?: {
									__typename?: 'Link'
									href?: string | null
								} | null
							} | null
					  }
					| null
			} | null> | null
		} | null
	} | null> | null
	relatedQuestions?: {
		__typename?: 'QuestionOutletContentRelatedQuestionsConnection'
		totalRelatedQuestions?: number | null
		edges?: Array<{
			__typename?: 'QuestionOutletContentRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
	commonRelatedQuestions?: {
		__typename?: 'QuestionOutletContentCommonRelatedQuestionsConnection'
		totalCommonRelatedQuestions?: number | null
		edges?: Array<{
			__typename?: 'QuestionOutletContentCommonRelatedQuestionsEdge'
			node?: {
				__typename?: 'Question'
				questionKey?: string | null
				content?: {
					__typename?: 'QuestionContent'
					question?: string | null
					isSustainable?: boolean | null
				} | null
				outletContent?: {
					__typename?: 'QuestionOutletContent'
					question?: string | null
					contentOverwriteSelector?: Array<string | null> | null
					isSustainable?: boolean | null
				} | null
				system?: { __typename?: 'EntrySystemField'; uid?: string | null } | null
			} | null
		} | null> | null
	} | null
} & { ' $fragmentName'?: 'QuestionOutletContentFragment' }

export type GetFrequentlyAskedQuestionsQueryVariables = Exact<{
	locale: Scalars['String']['input']
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetFrequentlyAskedQuestionsQuery = {
	__typename?: 'Query'
	allFaq?: {
		__typename?: 'AllFaq'
		items?: Array<{
			__typename?: 'Faq'
			content?:
				| ({ __typename?: 'FaqContent' } & {
						' $fragmentRefs'?: { FaqContentFragment: FaqContentFragment }
				  })
				| null
			outletContent?:
				| ({ __typename?: 'FaqOutletContent' } & {
						' $fragmentRefs'?: {
							FaqOutletContentFragment: FaqOutletContentFragment
						}
				  })
				| null
		} | null> | null
	} | null
}

export type GetQuestionsByCategoryKeyQueryVariables = Exact<{
	locale: Scalars['String']['input']
	categoryKey?: InputMaybe<Scalars['String']['input']>
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetQuestionsByCategoryKeyQuery = {
	__typename?: 'Query'
	allCategory?: {
		__typename?: 'AllCategory'
		total?: number | null
		items?: Array<{
			__typename?: 'Category'
			categoryKey?: string | null
			content?:
				| ({ __typename?: 'CategoryContent' } & {
						' $fragmentRefs'?: {
							CategoryContentFragment: CategoryContentFragment
						}
				  })
				| null
			outletContent?:
				| ({
						__typename?: 'CategoryOutletContent'
						contentOverwriteSelector?: Array<string | null> | null
				  } & {
						' $fragmentRefs'?: {
							CategoryOutletContentFragment: CategoryOutletContentFragment
						}
				  })
				| null
		} | null> | null
	} | null
}

export type GetQuestionByIdQueryVariables = Exact<{
	locale: Scalars['String']['input']
	questionKey: Scalars['String']['input']
	isOutlet?: Scalars['Boolean']['input']
}>

export type GetQuestionByIdQuery = {
	__typename?: 'Query'
	allQuestion?: {
		__typename?: 'AllQuestion'
		total?: number | null
		items?: Array<{
			__typename?: 'Question'
			questionKey?: string | null
			content?:
				| ({ __typename?: 'QuestionContent' } & {
						' $fragmentRefs'?: {
							QuestionContentFragment: QuestionContentFragment
						}
				  })
				| null
			outletContent?:
				| ({
						__typename?: 'QuestionOutletContent'
						contentOverwriteSelector?: Array<string | null> | null
				  } & {
						' $fragmentRefs'?: {
							QuestionOutletContentFragment: QuestionOutletContentFragment
						}
				  })
				| null
		} | null> | null
	} | null
}

export class TypedDocumentString<TResult, TVariables>
	extends String
	implements DocumentTypeDecoration<TResult, TVariables>
{
	__apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType']

	constructor(
		private value: string,
		public __meta__?: Record<string, any>
	) {
		super(value)
	}

	toString(): string & DocumentTypeDecoration<TResult, TVariables> {
		return this.value
	}
}
export const CategoriesFragmentDoc = new TypedDocumentString(
	`
    fragment Categories on CategoriesconfigContent {
  relatedCategories: related_categoriesConnection {
    edges {
      node {
        ... on Category {
          content {
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          system {
            uid
          }
          key: title
        }
      }
    }
    total: totalCount
  }
}
    `,
	{ fragmentName: 'Categories' }
) as unknown as TypedDocumentString<CategoriesFragment, unknown>
export const OutletCategoriesFragmentDoc = new TypedDocumentString(
	`
    fragment OutletCategories on CategoriesconfigOutletContent {
  relatedCategories: related_categoriesConnection {
    edges {
      node {
        ... on Category {
          content {
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          system {
            uid
          }
          key: title
        }
      }
    }
    total: totalCount
  }
}
    `,
	{ fragmentName: 'OutletCategories' }
) as unknown as TypedDocumentString<OutletCategoriesFragment, unknown>
export const ContactMethodsFragmentDoc = new TypedDocumentString(
	`
    fragment ContactMethods on ContactlabelsconfigContent {
  relatedContactLabels: related_contact_labelsConnection {
    edges {
      node {
        ... on Contactlabel {
          content {
            title
            type
            description
            analyticLabel: analytic_label
            link {
              href
              title
            }
            linkInNewTab: link_in_new_tab
          }
          system {
            uid
          }
        }
      }
    }
  }
  additionalInfo: additional_info
}
    `,
	{ fragmentName: 'ContactMethods' }
) as unknown as TypedDocumentString<ContactMethodsFragment, unknown>
export const OutletContactMethodsFragmentDoc = new TypedDocumentString(
	`
    fragment OutletContactMethods on ContactlabelsconfigOutletContent {
  relatedContactLabels: related_contact_labelsConnection {
    edges {
      node {
        ... on Contactlabel {
          content {
            title
            type
            description
            analyticLabel: analytic_label
            link {
              href
              title
            }
            linkInNewTab: link_in_new_tab
          }
          system {
            uid
          }
        }
      }
    }
  }
  additionalInfo: additional_info
}
    `,
	{ fragmentName: 'OutletContactMethods' }
) as unknown as TypedDocumentString<OutletContactMethodsFragment, unknown>
export const FaqContentFragmentDoc = new TypedDocumentString(
	`
    fragment FaqContent on FaqContent {
  title
  relatedQuestions: related_questions {
    relatedCategory: related_categoryConnection {
      edges {
        node {
          ... on Category {
            title
          }
        }
      }
    }
    relatedQuestion: related_questionConnection {
      edges {
        node {
          ... on Question {
            system {
              uid
            }
            content {
              question
              isSustainable: is_sustainable
            }
            outletContent: outlet_content @include(if: $isOutlet) {
              contentOverwriteSelector: content_overwrite_selector
              question
              isSustainable: is_sustainable
            }
            questionKey: title
          }
        }
      }
    }
  }
}
    `,
	{ fragmentName: 'FaqContent' }
) as unknown as TypedDocumentString<FaqContentFragment, unknown>
export const FaqOutletContentFragmentDoc = new TypedDocumentString(
	`
    fragment FaqOutletContent on FaqOutletContent {
  title
  relatedQuestions: related_questions {
    relatedCategory: related_categoryConnection {
      edges {
        node {
          ... on Category {
            title
          }
        }
      }
    }
    relatedQuestion: related_questionConnection {
      edges {
        node {
          ... on Question {
            system {
              uid
            }
            content {
              question
              isSustainable: is_sustainable
            }
            outletContent: outlet_content @include(if: $isOutlet) {
              contentOverwriteSelector: content_overwrite_selector
              question
              isSustainable: is_sustainable
            }
            questionKey: title
          }
        }
      }
    }
  }
}
    `,
	{ fragmentName: 'FaqOutletContent' }
) as unknown as TypedDocumentString<FaqOutletContentFragment, unknown>
export const CategoryContentFragmentDoc = new TypedDocumentString(
	`
    fragment CategoryContent on CategoryContent {
  title
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
}
    `,
	{ fragmentName: 'CategoryContent' }
) as unknown as TypedDocumentString<CategoryContentFragment, unknown>
export const CategoryOutletContentFragmentDoc = new TypedDocumentString(
	`
    fragment CategoryOutletContent on CategoryOutletContent {
  title
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
}
    `,
	{ fragmentName: 'CategoryOutletContent' }
) as unknown as TypedDocumentString<CategoryOutletContentFragment, unknown>
export const QuestionContentFragmentDoc = new TypedDocumentString(
	`
    fragment QuestionContent on QuestionContent {
  question
  isSustainable: is_sustainable
  answers {
    buttons: buttonsConnection {
      totalButtons: totalCount
      edges {
        node {
          ... on InternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
              isLegacy: islegacy
            }
          }
          ... on ExternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
            }
          }
        }
      }
    }
    text
  }
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalRelatedQuestions: totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalCommonRelatedQuestions: totalCount
  }
}
    `,
	{ fragmentName: 'QuestionContent' }
) as unknown as TypedDocumentString<QuestionContentFragment, unknown>
export const QuestionOutletContentFragmentDoc = new TypedDocumentString(
	`
    fragment QuestionOutletContent on QuestionOutletContent {
  question
  isSustainable: is_sustainable
  answers {
    buttons: buttonsConnection {
      totalButtons: totalCount
      edges {
        node {
          ... on InternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
              isLegacy: islegacy
            }
          }
          ... on ExternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
            }
          }
        }
      }
    }
    text
  }
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalRelatedQuestions: totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalCommonRelatedQuestions: totalCount
  }
}
    `,
	{ fragmentName: 'QuestionOutletContent' }
) as unknown as TypedDocumentString<QuestionOutletContentFragment, unknown>
export const GetBannerListDocument = new TypedDocumentString(`
    query GetBannerList($locale: String!, $isOutlet: Boolean! = false) {
  allCommBanners: all_banner(locale: $locale, where: {is_outlet: $isOutlet}) {
    items {
      content {
        subtitle
        title
      }
      system {
        uid
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
	GetBannerListQuery,
	GetBannerListQueryVariables
>
export const GetCategoryListDocument = new TypedDocumentString(`
    query GetCategoryList($locale: String!, $isOutlet: Boolean! = false) {
  allCategory: all_categoriesconfig(locale: $locale, limit: 1) {
    items {
      content {
        ...Categories
      }
      outletContent: outlet_content @include(if: $isOutlet) {
        ...OutletCategories
      }
    }
  }
}
    fragment Categories on CategoriesconfigContent {
  relatedCategories: related_categoriesConnection {
    edges {
      node {
        ... on Category {
          content {
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          system {
            uid
          }
          key: title
        }
      }
    }
    total: totalCount
  }
}
fragment OutletCategories on CategoriesconfigOutletContent {
  relatedCategories: related_categoriesConnection {
    edges {
      node {
        ... on Category {
          content {
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            title
            icon: iconConnection {
              edges {
                node {
                  ... on Icon {
                    title
                  }
                }
              }
            }
          }
          system {
            uid
          }
          key: title
        }
      }
    }
    total: totalCount
  }
}`) as unknown as TypedDocumentString<
	GetCategoryListQuery,
	GetCategoryListQueryVariables
>
export const GetContactLabelsListDocument = new TypedDocumentString(`
    query GetContactLabelsList($locale: String!, $isOutlet: Boolean! = false) {
  allContactLabels: all_contactlabelsconfig(locale: $locale, limit: 1) {
    items {
      content {
        ...ContactMethods
      }
      outletContent: outlet_content @include(if: $isOutlet) {
        ...OutletContactMethods
      }
    }
  }
}
    fragment ContactMethods on ContactlabelsconfigContent {
  relatedContactLabels: related_contact_labelsConnection {
    edges {
      node {
        ... on Contactlabel {
          content {
            title
            type
            description
            analyticLabel: analytic_label
            link {
              href
              title
            }
            linkInNewTab: link_in_new_tab
          }
          system {
            uid
          }
        }
      }
    }
  }
  additionalInfo: additional_info
}
fragment OutletContactMethods on ContactlabelsconfigOutletContent {
  relatedContactLabels: related_contact_labelsConnection {
    edges {
      node {
        ... on Contactlabel {
          content {
            title
            type
            description
            analyticLabel: analytic_label
            link {
              href
              title
            }
            linkInNewTab: link_in_new_tab
          }
          system {
            uid
          }
        }
      }
    }
  }
  additionalInfo: additional_info
}`) as unknown as TypedDocumentString<
	GetContactLabelsListQuery,
	GetContactLabelsListQueryVariables
>
export const GetHomepageAdditionalInfoDocument = new TypedDocumentString(`
    query GetHomepageAdditionalInfo($locale: String!, $isOutlet: Boolean! = false) {
  allHomepageAdditionalInfo: all_homepage_additional_info(locale: $locale) {
    items {
      content {
        labelKey: label_key
      }
      outletContent: outlet_content @include(if: $isOutlet) {
        labelKey: label_key
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
	GetHomepageAdditionalInfoQuery,
	GetHomepageAdditionalInfoQueryVariables
>
export const GetFrequentlyAskedQuestionsDocument = new TypedDocumentString(`
    query GetFrequentlyAskedQuestions($locale: String!, $isOutlet: Boolean! = false) {
  allFaq: all_faq(locale: $locale, limit: 1) {
    items {
      content {
        ...FaqContent
      }
      outletContent: outlet_content @include(if: $isOutlet) {
        ...FaqOutletContent
      }
    }
  }
}
    fragment FaqContent on FaqContent {
  title
  relatedQuestions: related_questions {
    relatedCategory: related_categoryConnection {
      edges {
        node {
          ... on Category {
            title
          }
        }
      }
    }
    relatedQuestion: related_questionConnection {
      edges {
        node {
          ... on Question {
            system {
              uid
            }
            content {
              question
              isSustainable: is_sustainable
            }
            outletContent: outlet_content @include(if: $isOutlet) {
              contentOverwriteSelector: content_overwrite_selector
              question
              isSustainable: is_sustainable
            }
            questionKey: title
          }
        }
      }
    }
  }
}
fragment FaqOutletContent on FaqOutletContent {
  title
  relatedQuestions: related_questions {
    relatedCategory: related_categoryConnection {
      edges {
        node {
          ... on Category {
            title
          }
        }
      }
    }
    relatedQuestion: related_questionConnection {
      edges {
        node {
          ... on Question {
            system {
              uid
            }
            content {
              question
              isSustainable: is_sustainable
            }
            outletContent: outlet_content @include(if: $isOutlet) {
              contentOverwriteSelector: content_overwrite_selector
              question
              isSustainable: is_sustainable
            }
            questionKey: title
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<
	GetFrequentlyAskedQuestionsQuery,
	GetFrequentlyAskedQuestionsQueryVariables
>
export const GetQuestionsByCategoryKeyDocument = new TypedDocumentString(`
    query GetQuestionsByCategoryKey($locale: String!, $categoryKey: String, $isOutlet: Boolean! = false) {
  allCategory: all_category(
    locale: $locale
    limit: 1
    where: {title: $categoryKey}
  ) {
    items {
      categoryKey: title
      content {
        ...CategoryContent
      }
      outletContent: outlet_content @include(if: $isOutlet) {
        contentOverwriteSelector: content_overwrite_selector
        ...CategoryOutletContent
      }
    }
    total
  }
}
    fragment CategoryContent on CategoryContent {
  title
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
}
fragment CategoryOutletContent on CategoryOutletContent {
  title
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          system {
            uid
          }
          questionKey: title
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
        }
      }
    }
    totalCount
  }
}`) as unknown as TypedDocumentString<
	GetQuestionsByCategoryKeyQuery,
	GetQuestionsByCategoryKeyQueryVariables
>
export const GetQuestionByIdDocument = new TypedDocumentString(`
    query GetQuestionById($locale: String!, $questionKey: String!, $isOutlet: Boolean! = false) {
  allQuestion: all_question(
    locale: $locale
    limit: 1
    where: {title: $questionKey}
  ) {
    items {
      questionKey: title
      content {
        ...QuestionContent
      }
      outletContent: outlet_content @include(if: $isOutlet) {
        contentOverwriteSelector: content_overwrite_selector
        ...QuestionOutletContent
      }
    }
    total
  }
}
    fragment QuestionContent on QuestionContent {
  question
  isSustainable: is_sustainable
  answers {
    buttons: buttonsConnection {
      totalButtons: totalCount
      edges {
        node {
          ... on InternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
              isLegacy: islegacy
            }
          }
          ... on ExternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
            }
          }
        }
      }
    }
    text
  }
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalRelatedQuestions: totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalCommonRelatedQuestions: totalCount
  }
}
fragment QuestionOutletContent on QuestionOutletContent {
  question
  isSustainable: is_sustainable
  answers {
    buttons: buttonsConnection {
      totalButtons: totalCount
      edges {
        node {
          ... on InternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
              isLegacy: islegacy
            }
          }
          ... on ExternalLinkButton {
            buttonKey: title
            content {
              labelKey: label_key
              link {
                href
              }
              loggedLink: logged_link {
                href
              }
              outletLink: outlet_link {
                href
              }
              outletLoggedLink: outlet_logged_link {
                href
              }
              linkInNewTab: link_in_new_tab
              actions
            }
          }
        }
      }
    }
    text
  }
  relatedQuestions: related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalRelatedQuestions: totalCount
  }
  commonRelatedQuestions: common_related_questionsConnection {
    edges {
      node {
        ... on Question {
          content {
            question
            isSustainable: is_sustainable
          }
          outletContent: outlet_content @include(if: $isOutlet) {
            contentOverwriteSelector: content_overwrite_selector
            question
            isSustainable: is_sustainable
          }
          questionKey: title
          system {
            uid
          }
        }
      }
    }
    totalCommonRelatedQuestions: totalCount
  }
}`) as unknown as TypedDocumentString<
	GetQuestionByIdQuery,
	GetQuestionByIdQueryVariables
>
